module.exports = __webpack_public_path__ + "static/Brex-9661e46fdcd8eec02637426fdde3897f.jpg";